import errorTrackerV2 from "./Utils/ErrorTrackerV2";
import { auth } from "../../../../../backend/firebaseConfig";

export const validateSection9 = ({
  formData,
  setErrors,
  setIsValid,
  onValidationStatusChange,
}) => {
  const newErrors = {};

  // If data is null, all required fields are missing
  if (formData === null || formData === undefined) {
    newErrors["dataNotFound"] =
      "No data found for this section. Please open and save it first.";
    errorTrackerV2.setSectionErrors("section9", newErrors);
    onValidationStatusChange?.(false);
    return false;
  }

  // bypass: no errors, mark valid
  // if (shouldBypassValidation(auth.currentUser?.uid)) {
  //   setErrors({});
  //   setIsValid?.(true);
  //   errorTrackerV2.setSectionErrors("section9", {});
  //   onValidationStatusChange?.(true);
  //   return true;
  // }

  const f = formData;
  // const newErrors = {};

  const req = (cond, key, msg = "This field is required.") => {
    if (cond) newErrors[key] = msg;
  };

  // 1) Branding support option required
  req(
    !Array.isArray(f.brandingAndMarketingSupportOptions) ||
      f.brandingAndMarketingSupportOptions.length === 0,
    "brandingAndMarketingSupportOptions",
    "Please select at least one option.",
  );

  // 2) Branding services required
  req(
    !Array.isArray(f.brandingAndMarketingServices) ||
      f.brandingAndMarketingServices.length === 0,
    "brandingAndMarketingServices",
    "Please select at least one option.",
  );

  // 3) For every checked document, at least 1 file must exist
  (f.checkAndDocumentEnclosed || []).forEach((documentKey) => {
    const filesForDoc = f.files?.[documentKey] || [];
    req(
      !Array.isArray(filesForDoc) || filesForDoc.length === 0,
      documentKey,
      `Please upload at least one file for "${documentKey}".`,
    );
  });

  setErrors(newErrors);
  errorTrackerV2.setSectionErrors("section9", newErrors);

  const ok = Object.keys(newErrors).length === 0;
  setIsValid?.(ok);
  onValidationStatusChange?.(ok);

  return ok;
};
